export default __webpack_public_path__ + "static/media/dc-main-mob.839e680e.png";